export const FETCH = 'artful-client/AppFeatures/FETCH';
export const FETCH_SUCCESS = 'artful-client/AppFeatures/FETCH_SUCCESS';
export const FETCH_FAILURE = 'artful-client/AppFeatures/FETCH_FAILURE';
